module.exports = __webpack_public_path__ + "static/media/icon-edit-light-blue.fd60b43e.svg";